'use strict';

var App = require('app');
var ModbusModel = require('models/modbus').Modbus;
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');
var Strings = require('utils/strings');

var ModbusView = Backbone.Marionette.ItemView.extend({
    template: require('components/devices/templates/controller/modbus'),

    ui: {
        register: '#js-mb-register',
        registerW: '#js-mb-register-w',
        registerValueW: '#js-mb-value-w',

        coil: '#js-mb-coil',
        coilW: '#js-mb-coil-w',
        coilValueW: '#js-mb-coil-value-w',

        inputRegister: '#js-mb-input',
        discreteInput: '#js-mb-discrete',

        apn: '#js-mb-apn',
        apnValueW: '#js-mb-apn-value-w',
    },

    events: {
        'click button.js-mb-request': 'request',
        'click button.js-mb-request-w': 'write',
    },

    initialize: function (options) {},

    setPermission: function (permissions) {},

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.response = this.response;

        return data;
    },

    getReadControl: function (type) {
        switch (type) {
            case 'coil':
                return this.ui.coil;
            case 'input':
                return this.ui.inputRegister;
            case 'discrete':
                return this.ui.discreteInput;
            default:
                return this.ui.register;
        }
    },

    request: function (e) {
        e.preventDefault();

        var type = e.currentTarget.id.substring(8);

        var self = this;
        Decorator.disableElement('.js-request-card');

        var value = this.getReadControl(type).val();
        var mbResponse = App.request('modbus:request', this.model.id, type, value);
        $.when(mbResponse).done(function (mbResponse) {
            if (mbResponse === undefined) {
                Decorator.enableElement('.js-request-card');
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Register konnte nicht gelesen werden.'));
                return;
            }

            self.response = mbResponse;
            if (type == 'apn' && self.response.attributes.registers) {
                var apn1 = Strings.registersToString(self.response.attributes.registers.slice(0, 16));
                var apn2 = Strings.registersToString(self.response.attributes.registers.slice(16));
                self.response.attributes.registers = { APN1: apn1, APN2: apn2 };
            }

            self.render();
        });
    },

    write: function (e) {
        e.preventDefault();

        var type = e.currentTarget.id.substring(9);

        var self = this;
        Decorator.disableElement('.js-request-card');

        var mbValue = new ModbusModel({
            id:
                type == 'apn'
                    ? 0 //dummy value
                    : parseInt(type == 'coil' ? this.ui.coilW.val() : this.ui.registerW.val()),
            device: parseInt(this.model.id),
            type: type,
            value:
                type == 'apn'
                    ? 0 //dummy value
                    : parseInt(type == 'coil' ? this.ui.coilValueW.val() : this.ui.registerValueW.val()),
            apn: type == 'apn' ? this.ui.apnValueW.val() : '',

            is_relative: false,
        });
        mbValue.save(
            {},
            {
                success: function (model, response) {
                    self.response = response;
                    self.render();
                },
                error: function (model, r) {
                    var errInfo = r.responseJSON || { error: r.responseText };
                    Decorator.enableElement('.js-request-card');
                    Notification.show('error', i18n.TR('Fehler'), i18n.TR(errInfo.error));
                },
            }
        );
    },
});

module.exports = ModbusView;
